<script>
  import {fade} from 'svelte/transition';

  import {DRIVERS_BY_SIZE}       from '../../../../../constants/drivers-by-size';
  import {sizeClass}             from '../../../../../services/size-class';
  import {driverSizesStore}      from '../../../../../stores/filters/driver-sizes-store';
  import {driverStore}           from '../../../../../stores/filters/driver-store';
  import {showDriverPickerStore} from '../../../../../stores/filters/show-driver-picker-store';

  const removeDriverPicker = (_event) => {
    $showDriverPickerStore = false;
  };

  $: sizeFilteredDrivers = (() => {
    const result = [];

    $driverSizesStore.forEach((size) => {
      const groups = DRIVERS_BY_SIZE[size];
      groups.forEach((group) => {
        const names = group[0];
        names.forEach((name) => { result.push({name, size}); });
      });
    });

    return result.sort((d1, d2) => {
      if (d1.name < d2.name) return -1;
      if (d1.name > d2.name) return 1;
      return 0;
    });
  })();

  const selectDriver = (driver) => {
    $driverStore = driver;
    removeDriverPicker();
  };
</script>

<style>
  #drivers-picker-wrapper {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
  }

  #drivers-picker {
    background-color: white;
    border-radius: 30px;
    margin: 20px auto;
    max-height: 90%;
    max-width: 730px;
    overflow: auto;
    padding: 10px;
    width: 95%;
  }

  .driver {
    border: 1px solid gray;
    border-radius: 20px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    float: left;
    height: 39px;
    margin: 2px;
    padding: 9px 0 0 0;
    text-align: center;
    width: 172px;
  }

  .driver img {
    margin: -7px 7px;
  }

  .all-drivers {
    background-color: lightgray;
    padding: 1px 0 0 0;
  }
</style>

<template lang="pug" src="./driver-picker.pug"></template>
